import _ from "lodash";

function addIfString(targetSet, value) {
	if (_.isString(value) && !_.isEmpty(_.trim(value))) {
		targetSet.add(value);
	}
}

function collectChecklistDriveReferences(value, references) {
	if (_.isNil(value)) {
		return;
	}

	if (_.isArray(value)) {
		value.forEach((entry) => collectChecklistDriveReferences(entry, references));
		return;
	}

	if (!_.isPlainObject(value)) {
		return;
	}

	if (value.type === "resource/ref") {
		addIfString(references.resourceIds, value.refId);
		return;
	}

	if (value.type === "resource/external/drive") {
		addIfString(references.guids, value.guid);
		addIfString(references.resourceIds, value.id);
		addIfString(references.paths, value.path);
	}

	_.forEach(value, (childValue, key) => {
		if (_.isString(childValue) && /drive|resource/i.test(key)) {
			addIfString(references.guids, childValue);
			addIfString(references.paths, childValue);
			addIfString(references.resourceIds, childValue);
		}
		collectChecklistDriveReferences(childValue, references);
	});
}

export function buildPreviewDrivePayloadForChecklist(checklist = {}, ...driveSources) {
	const sourceGuidToResource = {};
	const sourcePathToResource = {};
	const sourceResourcesById = {};

	driveSources.forEach((driveSource) => {
		if (!_.isObject(driveSource)) {
			return;
		}
		_.assign(sourceGuidToResource, _.get(driveSource, "guidToResource", {}) || {});
		_.assign(sourcePathToResource, _.get(driveSource, "pathToResource", {}) || {});
	});

	const externalResources = _.isArray(_.get(checklist, "externalResources")) ? checklist.externalResources : [];
	const externalDriveResources = externalResources.filter((resource) => {
		return resource && resource.type === "resource/external/drive" && _.isString(resource.guid) && !_.isEmpty(resource.guid);
	});

	const externalResourcesByGuid = {};
	const externalResourcesById = {};
	const externalResourcesByPath = {};
	const references = {
		guids: new Set(),
		resourceIds: new Set(),
		paths: new Set()
	};
	const guidToResource = {};
	const pathToResource = {};

	_.forEach(sourceGuidToResource, (resource) => {
		const id = _.get(resource, "id", "");
		if (_.isString(id) && !_.isEmpty(id)) {
			sourceResourcesById[id] = resource;
		}
	});

	_.forEach(sourcePathToResource, (resource) => {
		const id = _.get(resource, "id", "");
		if (_.isString(id) && !_.isEmpty(id) && !sourceResourcesById[id]) {
			sourceResourcesById[id] = resource;
		}
	});

	externalDriveResources.forEach((resource) => {
		externalResourcesByGuid[resource.guid] = resource;
		addIfString(references.guids, resource.guid);
		if (_.isString(resource.id) && !_.isEmpty(resource.id)) {
			externalResourcesById[resource.id] = resource;
			references.resourceIds.add(resource.id);
		}
		if (_.isString(resource.path) && !_.isEmpty(resource.path)) {
			externalResourcesByPath[resource.path] = resource;
			references.paths.add(resource.path);
		}
	});

	collectChecklistDriveReferences(checklist, references);

	const includeResource = (resource) => {
		if (!_.isObject(resource)) {
			return;
		}
		const guid = _.get(resource, "guid", "");
		const path = _.get(resource, "path", "");
		if (_.isString(guid) && !_.isEmpty(guid)) {
			guidToResource[guid] = resource;
		}
		if (_.isString(path) && !_.isEmpty(path)) {
			pathToResource[path] = resource;
		}
	};

	references.guids.forEach((guid) => includeResource(sourceGuidToResource[guid] || externalResourcesByGuid[guid]));
	references.resourceIds.forEach((resourceId) => includeResource(sourceResourcesById[resourceId] || externalResourcesById[resourceId]));
	references.paths.forEach((path) => includeResource(sourcePathToResource[path] || externalResourcesByPath[path]));

	_.forEach(sourcePathToResource, (resource, path) => {
		const guid = _.get(resource, "guid", "");
		const id = _.get(resource, "id", "");
		if (references.guids.has(guid) || references.resourceIds.has(id) || references.paths.has(path)) {
			includeResource(resource);
		}
	});

	return {
		guidToResource,
		pathToResource
	};
}
